export default __webpack_public_path__ + "static/media/petra.cc7bce81.png";